import { Button } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import "./FontAdmin.css";

export type FontDefinition = {
  id: number;
  name: string;
  url: string;
};

function FontAdmin() {
  const [fonts, setFonts] = useState<Array<FontDefinition>>([]);
  const [saveResult, setSaveResult] = useState<string>("");

  useEffect(() => {
    fetch("/api/fonts")
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then((data) => {
        setFonts(data.fonts);
      });
  }, []);

  function addFont() {
    setFonts((prev) => {
      let maxNumber = Math.max(...prev.map((font) => parseInt(font.name.slice(4)) || 0), 0);
      let newId = prev.length > 0 ? Math.max(...prev.map((font) => font.id)) + 1 : 1;
      return [...prev, { id: newId, name: "font" + (maxNumber + 1), url: "" }];
    });
  }

  function changeFontName(id: number, event: ChangeEvent<HTMLInputElement>) {
    let newName = event.target.value;
    setFonts((prev) =>
      prev.map((font) => {
        if (font.id === id) {
          return { ...font, name: newName };
        }
        return font;
      }),
    );
  }

  function changeFontUrl(id: number, event: ChangeEvent<HTMLInputElement>) {
    let newUrl = event.target.value;
    setFonts((prev) =>
      prev.map((font) => {
        if (font.id === id) {
          return { ...font, url: newUrl };
        }
        return font;
      }),
    );
  }

  function saveFonts() {
    fetch("/api/fonts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fonts }),
    })
      .then((response) => {
        if (response.ok) {
          setSaveResult("Fonts saved successfully.");
          window.location.reload();
        }
      })
      .catch((error) => {
        setSaveResult("Error saving fonts.");
        console.error("Error saving fonts:", error);
      });
  }

  let fontElements = fonts.map((font) => (
    <div key={font.id} className="font-admin-font-row">
      <label htmlFor={`font-name-${font.id}`}>Name:</label>
      <input
        id={`font-name-${font.id}`}
        type="text"
        defaultValue={font.name}
        onChange={(e) => changeFontName(font.id, e)}
      />
      <label htmlFor={`font-url-${font.id}`}>URL:</label>
      <input
        id={`font-url-${font.id}`}
        type="text"
        defaultValue={font.url}
        onChange={(e) => changeFontUrl(font.id, e)}
        className="font-admin-url-input"
      />
    </div>
  ));
  let fontList =
    fontElements.length > 0 ? <div className="font-definition-list">{fontElements}</div> : <p>No fonts available.</p>;

  return (
    <div>
      <h1>Font Admin</h1>
      {fontList}
      <div className="font-admin-buttons">
        <Button variant="contained" color="primary" onClick={addFont}>
          Add Font
        </Button>
        <Button variant="contained" color="success" onClick={saveFonts}>
          Save Changes
        </Button>
      </div>
      {saveResult && <p>{saveResult}</p>}
    </div>
  );
}

export default FontAdmin;
